import SubscriptionsIcon from '@mui/icons-material/Subscriptions';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link as RouterLink } from 'react-router-dom';
import { youtubePanoramaMessages } from '../../panorama/youtube-panorama.messages';
import { youtubeBroadcastsListRouteGenerator } from '../list/youtube-broadcasts-list-routes';
import { youtubeNativeRecentTransmissionsMessages } from './youtube-broadcasts.messages';
import { YoutubeBroadcastsLoading } from './YoutubeBroadcastsLoading';
import { YoutubeOfflineHeader } from './YoutubeOfflineHeader';

interface YoutubeRecentBroadcastsShellProps {
  children?: ReactNode;
  loading?: boolean;
  stationSlug?: string;
}

/** Shared layout for the recent YouTube broadcasts panel (header, title, list or skeleton). */
export function YoutubeRecentBroadcastsShell({
  children,
  loading = false,
  stationSlug,
}: YoutubeRecentBroadcastsShellProps) {
  const { formatMessage } = useIntl();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        width: '100%',
        maxWidth: 'md',
        mx: 'auto',
        px: 2,
        py: 1,
      }}
    >
      <Box sx={{ mx: 'auto', mb: 2 }}>
        <YoutubeOfflineHeader />
      </Box>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
          mb: 0.5,
          ml: 1,
        }}
      >
        <Typography
          sx={{
            typography: 'caption',
            color: 'text.secondary',
            textTransform: 'uppercase',
            letterSpacing: '0.08em',
          }}
        >
          {formatMessage(youtubeNativeRecentTransmissionsMessages.last24h)}
        </Typography>
        {stationSlug ? (
          <Tooltip title={<FormattedMessage {...youtubePanoramaMessages.viewAll} />}>
            <IconButton
              component={RouterLink}
              to={youtubeBroadcastsListRouteGenerator.list(stationSlug)}
              color="primary"
              size="small"
              sx={{ flexShrink: 0 }}
            >
              <SubscriptionsIcon sx={{ fontSize: 20 }} />
            </IconButton>
          </Tooltip>
        ) : null}
      </Box>

      {loading ? <YoutubeBroadcastsLoading /> : children}
    </Box>
  );
}
